import RequestStatus from '../store/schema/RequestStatus';
import { ITheme } from '@uifabric/styling';
import { ISuggestionsHeaderFooterProps } from 'office-ui-fabric-react/lib/FloatingPicker';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { generateLocationWellColor } from '../utils/generateLocationWellStyle';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-calendar-strings';
import * as React from 'react';

const styles = require('../components/LocationCommonWell.scss');

export function getHeaderItemProps(
    queryString: string,
    numOfSuggestions: number,
    colorScheme?: ColorScheme,
    disableUseThisLocationButton?: boolean
): ISuggestionsHeaderFooterProps[] {
    const headerTextColorStyle = generateLocationWellColor(colorScheme).rootColor;
    return [
        {
            renderItem: () => {
                return (
                    <span className={styles.header} style={{ color: headerTextColorStyle }}>
                        {strings.suggestedLocationsText}
                    </span>
                );
            },
            shouldShow: () => {
                return queryString.length === 0 && numOfSuggestions > 0;
            },
        },
        {
            renderItem: () => {
                const headerText = format(strings.useThisLocationText, queryString);
                return (
                    <span className={styles.header} style={{ color: headerTextColorStyle }}>
                        {headerText}
                    </span>
                );
            },
            shouldShow: () => {
                // Show 'Use this location' when there is text in the input field
                return queryString.length > 0 && !disableUseThisLocationButton;
            },
        },
    ];
}

export function getFooterItemProps(
    queryString: string,
    findLocationRequestStatus: RequestStatus,
    numOfSuggestions: number,
    theme?: ITheme
): ISuggestionsHeaderFooterProps[] {
    return [
        {
            renderItem: () => {
                const footerText = format(strings.findLocationInfo_Searching, queryString);
                return (
                    <div className={styles.footer}>
                        <Spinner className={styles.spinner} theme={theme} />
                        <span className={styles.footerText}>{footerText}</span>
                    </div>
                );
            },
            shouldShow: () => {
                // Show the spinner when the findLocation service request is pending
                return findLocationRequestStatus === RequestStatus.Pending;
            },
        },
        {
            renderItem: () => {
                return (
                    <div className={styles.footer}>
                        <span className={styles.footerText}>
                            {strings.findLocationInfo_NoMatchFound}
                        </span>
                    </div>
                );
            },
            shouldShow: () => {
                return queryString.length > 0 && numOfSuggestions == 0;
            },
        },
    ];
}
